/*
 * @Author: zwcong
 * @Description:
 * @Date: 2021-12-07 17:25:44
 * @LastEditTime: 2022-03-18 17:19:31
 * @FilePath: /app-teacher-h5/src/service/login/index.js
 */
import http from '../http'
import url from './index-url'
const { get, post } = http

export default {
  querySubjectGrade(data) {
    return get(url.querySubjectGrade, data)
  },
  queryLessonList(data) {
    return get(url.queryLessonList, data)
  },
  getReportList(data) {
    return get(url.report(data.studentUserId), data)
  },
  consolidation(data) {
    return get(url.consolidation(data.studentUserId), data)
  },
  book(data) {
    return get(url.book(data.studentUserId), data)
  },
  getAnswerRecords(data) {
    return get(url.queryLessonsAnswerRecords, data)
  },
  operationCoinRecord(data) {
    return get(url.operationCoinRecord, {
      ...data,
      pageNum: 1,
      pageSize: 2000
    })
  },
  operationCoin(data) {
    return post(url.operationCoin, data)
  },
  getConsolidationDetails(data) {
    return get(url.getConsolidationDetails(data.lessonId, data.studentUserId, data.groupId), {
      ...data,
      pageNum: 1,
      pageSize: 2000
    })
  },
  getBookDetails(data) {
    return get(url.getBookDetails(data.lessonId, data.studentUserId, data.groupId), {
      ...data,
      pageNum: 1,
      pageSize: 2000
    })
  },
  getStudentDetail(data) {
    return get(url.getStudentDetail, data)
  },
  studentSummary({ studentUserId }) {
    return get(url.studentSummary(studentUserId))
  },
  delLesson(data) {
    return post(url.delLesson, data)
  },
  lessonRecord(data) {
    return post(url.lessonRecord, data)
  },
  changeLesson(data) {
    return post(url.changeLesson, data)
  },
  studentCardDetail({ studentUserId }) {
    return get(url.studentCardDetail(studentUserId))
  }
}